export default "__VITE_ASSET__cGXeTVpD__"